import * as React from 'react';

import noop from 'helper/noop';

import Knob, { KnobProps, KnobTypeProps } from 'components/atoms/Knob';

export type ButtonProps = {
	id?: string;
	labelTop?: string;
	labelBottom?: string;
	key?: string;
	knob?: KnobProps;
	type?: KnobTypeProps;
	disabled?: boolean;
	loading?: boolean;
	modifier?: string;
	link?: any;
	handleButtonClick?: (iconOrId: string, ev: React.MouseEvent<any>) => void;
};

const Button = ({
	knob,
	labelTop,
	labelBottom,
	type,
	handleButtonClick,
	disabled = false,
	loading = false,
	modifier,
}: ButtonProps) => {
	const getStatefulEventHandler = (k: KnobProps | Function, t: string | Function) => {
		if (disabled || loading || t === 'disabled') {
			return noop;
		}

		return (ev: React.MouseEvent<HTMLDivElement>) => {
			if (handleButtonClick) {
				handleButtonClick.apply(null, [(k as KnobProps).icon, ev]);
			}
		};
	};

	const className = (): string => {
		const out: Array<string> = ['m-button'];
		if (labelTop) {
			out.push('m-button--before');
		}
		if (type) {
			out.push(`state-m-button--${type}`);
		}
		if (disabled) {
			out.push('state-m-button--disabled');
		}
		if (loading) {
			out.push('state-m-button--loading');
		}
		if (modifier) {
			out.push(`m-button--${modifier}`);
		}
		return out.join(' ');
	};

	return (
		<div className={className()} onClick={getStatefulEventHandler(knob as KnobProps, type as string)}>
			{labelTop && <span className="m-button__text">{labelTop}</span>}
			{knob && (
				<Knob
					modifier={knob.modifier}
					size={knob.size}
					icon={knob.icon}
					type={knob && knob.type ? knob.type : type || ''}
					disabled={disabled}
					loading={loading}
				/>
			)}

			{labelBottom && <span className="m-button__text">{labelBottom}</span>}
		</div>
	);
};

export default Button;
